export default "__VITE_ASSET__165d15e9__"